import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import { ReactComponent as Logo } from '../../assets/images/sidebar/logo.svg';
import { ReactComponent as BigLogo } from '../../assets/images/sidebar/big-logo.svg';
import { ReactComponent as HomeIcon } from '../../assets/images/sidebar/home-icon.svg';
import { ReactComponent as EmployeesIcon } from '../../assets/images/sidebar/employees-icon.svg';
import { ReactComponent as CalendarIcon } from '../../assets/images/sidebar/calendar-icon.svg';
import { ReactComponent as ProjectsIcon } from '../../assets/images/sidebar/projects-icon.svg';
import { ReactComponent as CarSvg } from '../../assets/images/sidebar/car.svg';
import { ReactComponent as CustomersIcon } from '../../assets/images/sidebar/customers-icon.svg';
import { ReactComponent as TrainingsIcon } from '../../assets/images/sidebar/trainings-icon.svg';
import { ReactComponent as ScheduleIcon } from '../../assets/images/sidebar/schedule-icon.svg';
import { ReactComponent as ReportsIcon } from '../../assets/images/sidebar/reports-icon.svg';
import { ReactComponent as Bell } from '../../assets/images/sidebar/bell.svg';
import { ReactComponent as Search } from '../../assets/images/sidebar/search.svg';
import AvatarImg from '../../assets/images/sidebar/avatar.png';
import { Avatar, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import SideBarItem from './SideBarItem';
import UserMenu from '../menu/UserMenu';
import { useTranslation } from 'react-i18next';
import { usePermission } from '../../hooks/usePermission';
import { useVisibleLinks } from '../../hooks/useVisibleLinks';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  borderRadius: '30px',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: '85px',
  //   [theme.breakpoints.up('sm')]: {
  //     width: '92px',
  //   },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',

  '.MuiDrawer-paper': {
    backgroundColor: theme.palette.blue.dark,
    borderRadius: '100px',
  },

  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

// const links = [
//   { label: 'בית', link: '/', Icon: HomeIcon },
//   { label: 'ניהול עובדים', link: '/employees', Icon: EmployeesIcon },
//   { label: 'ניהול פרויקטים', link: '/projects', Icon: ProjectsIcon },
//   { label: 'ניהול רכבים', link: '/cars', Icon: CarSvg },
//   {
//     label: 'ניהול לקוחות',
//     link: '/customer-management',
//     Icon: CustomersIcon,
//   },
//   { label: 'ניהול הדרכות', link: '/trainings', Icon: TrainingsIcon },
//   { label: 'סידור עבודה', link: '/login', Icon: ScheduleIcon },
//   { label: 'ניהול דוחות', link: '/', Icon: ReportsIcon },
//   {
//     label: 'טפסי מאסטר',
//     link: '/',
//     Icon: ReportsIcon,
//     submenu: [
//       { label: 'מְפַקֵחַ', link: '/inspectors' },
//       { label: 'חֶברָה', link: '/company' },
//     ],
//   },
// ];

const openSideBarStyle = {
  margin: '16px 7px 0',
  minHeight: 'unset',
  padding: '12px 9px',
  borderRadius: '4.31px',
  boxShadow: '0px 5.75px 17.25px -5.75px rgba(0, 0, 0, 0.1)',
};

const SideBar = () => {
  const { t } = useTranslation('menu');
  const auth = useSelector((s) => s.auth);
  console.log(JSON.stringify(auth));
  const permissions = useSelector((s) => s.auth.permissions);

  const hasPerm = (perm) => !perm || permissions.includes(perm);
  let accessToken = localStorage.getItem('token');
  let decoded = '';
  let roledata = '';
  if (accessToken) {
    decoded = jwtDecode(accessToken);
    roledata = decoded?.data?.roleId;
  }

  let links = [
    {
      label: t('menu.home'),
      link: '/',
      Icon: HomeIcon,
      permission: 'Dashboard.menu',
    },
    {
      label: t('menu.employees'),
      link: '/employees',
      Icon: EmployeesIcon,
      permission: 'Employee.menu',
    },
    {
      label: t('menu.work-days-management'),
      link: '/work-days-management',
      Icon: CalendarIcon,
      permission: 'WorkDayManagement.menu',
    },
    {
      label: t('menu.projects'),
      link: '/projects',
      Icon: ProjectsIcon,
      permission: 'Project.menu',
    },
    {
      label: t('menu.cars'),
      link: '/cars',
      Icon: CarSvg,
      permission: 'Car.menu',
    },
    {
      label: t('menu.customers'),
      link: '/customer-management',
      Icon: CustomersIcon,
      permission: 'Client.menu',
    },
    {
      label: t('menu.trainings'),
      link: '/trainings',
      Icon: TrainingsIcon,
      permission: 'License.menu',
    },
    {
      label: t('menu.schedule'),
      link: '/work-arrangement',
      Icon: ScheduleIcon,
      permission: 'WorkArrangement.menu',
    },
    // {
    //   label: t('menu.reports'),
    //   link: '/',
    //   Icon: ReportsIcon,
    //   permission: 'Report.menu',
    // },
    {
      label: t('menu.contracts'),
      link: '/contracts',
      permission: 'Contract.menu',
      Icon: ReportsIcon,
    },
    {
      label: t('menu.master_forms'),
      link: '',
      Icon: ReportsIcon,
      submenu: [
        {
          label: t('menu.inspector'),
          link: '/inspectors',
          permission: 'Inspector.menu',
        },
        {
          label: t('menu.company'),
          link: '/company',
          permission: 'Company.menu',
        },
        {
          label: t('menu.globalSettings'),
          link: '/global-settings',
          permission: 'Permissions.menu',
        },
      ],
    },
  ];
  if (decoded?.data?.roleId == 5) {
    links = [];
  }

  const links2 = [
    {
      label: t('menu.home'),
      link: '/',
      Icon: HomeIcon,
      permission: 'Project.view',
    },
    {
      label: t('menu.employees'),
      link: '/employees',
      Icon: EmployeesIcon,
      permission: 'Employee.view',
    },
    {
      label: t('menu.projects'),
      link: '/projects',
      Icon: ProjectsIcon,
      permission: 'Project.view',
    },
    {
      label: t('menu.cars'),
      link: '/cars',
      Icon: CarSvg,
      permission: 'Car.view',
    },
    {
      label: t('menu.customers'),
      link: '/customer-management',
      Icon: CustomersIcon,
    },
    {
      label: t('menu.trainings'),
      link: '/trainings',
      Icon: TrainingsIcon,
      permission: 'License.view',
    },
    {
      label: t('menu.schedule'),
      link: '/work-arrangement',
      Icon: ScheduleIcon,
      permission: 'WorkArrangement.view',
    },
    {
      Icon: ReportsIcon,
      label: t('menu.contracts'),
      link: '/contracts',
      permission: 'Contract.view',
    },
    // {
    //   label: t('menu.reports'),
    //   link: '/',
    //   Icon: ReportsIcon,
    //   permission: 'Report.view',
    // },
    {
      label: t('menu.master_forms'),
      link: '/',
      Icon: ReportsIcon,
      submenu: [
        {
          label: t('menu.inspector'),
          link: '/inspectors',
          permission: 'Inspector.view',
        },
        {
          label: t('menu.company'),
          link: '/company',
          permission: 'Company.view',
        },
        {
          label: t('menu.contracts'),
          link: '/contracts',
          permission: 'Contract.view',
        },
        {
          label: t('menu.globalSettings'),
          link: '/global-settings',
          permission: 'Permissions.view',
        },
      ],
    },
  ];

  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const visibleLinks = useVisibleLinks(links, permissions);
  //   const visibleLinks3 = links
  //     .map((item) => {
  //       // filter submenu first (if any)
  //       const visibleSub =
  //         item.submenu?.filter((s) => hasPerm(s.permission)) || [];
  // console.log(item.permission + " - " +hasPerm(item.permission))
  //       // if parent has no permission OR submenu left → keep it
  //       const keepParent = hasPerm(item.permission) || visibleSub.length > 0;

  //       return keepParent ? { ...item, submenu: visibleSub } : null;
  //     })
  //     .filter(Boolean); // remove nulls

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const showVisibleLink = () => {
    //  alert(JSON.stringify(visibleLinks))
    //  alert(JSON.stringify(permissions))
  };
  return (
    <>
      <Drawer
        variant="permanent"
        open={open}
        onMouseEnter={handleDrawerOpen}
        onMouseLeave={handleDrawerClose}
      >
        <DrawerHeader>
          <Link to={'/'}>
            <Box sx={!open ? openSideBarStyle : { margin: '17px 0 0px 30px' }}>
              {open ? <BigLogo /> : <Logo />}
            </Box>
          </Link>

          {/* <Box sx={{ padding: '24px 31px' }}>
            <Search />
          </Box> */}
        </DrawerHeader>
        <Divider sx={{ backgroundColor: 'rgba(246, 248, 250, 1)' }} />
        {/* <List>
        {links.map((item) => {
          const { label, link, Icon, submenu } = item;
          return (
            <SideBarItem
              key={label}
              label={label}
              link={link}
              Icon={Icon}
              open={open}
              submenu={submenu}
            />
          );
        })}
      </List>  */}

        <List>
          {visibleLinks.map(({ label, link, Icon, submenu }) => (
            <SideBarItem
              key={label}
              label={label}
              link={link}
              Icon={Icon}
              open={open}
              submenu={submenu}
            />
          ))}
        </List>

        <Divider sx={{ backgroundColor: 'rgba(246, 248, 250, 1)' }} />
        {/* <Box className="bell">
          <IconButton>
            <Bell />
          </IconButton>
        </Box> */}
        {/* <Box className="avatar">
        <IconButton>
          <Avatar alt="Ploni Ploni" src={AvatarImg} />
        </IconButton>
      </Box> */}

        <UserMenu />
      </Drawer>
    </>
  );
};

export default SideBar;
